import { Banner } from ".";
import { Link } from "../link";

interface LiquidationBannerProps {
  className?: string;
  marketsAtRiskOfLiquidation: number;
  href: string;
}

export function LiquidationBanner({
  className,
  marketsAtRiskOfLiquidation,
  href,
}: LiquidationBannerProps): JSX.Element {
  return (
    <Banner
      className={className}
      icon={
        <Banner.Icon className={Banner.icon({ className: "text-red-400" })} />
      }
      content={
        <p className="block">
          <span>
            <span className="font-bold">
              {marketsAtRiskOfLiquidation} of your positions{" "}
              {marketsAtRiskOfLiquidation === 1 ? "is" : "are"} at risk of
              liquidation{" "}
            </span>
            and require{marketsAtRiskOfLiquidation === 1 ? "s" : ""} your
            attention.{" "}
          </span>
          <Link href={href} className="!font-medium !text-blue-300">
            See more
          </Link>
        </p>
      }
    />
  );
}
